import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { AlertIcon, Button, colors, DownloadIcon, EditIcon } from '@diversioteam/diversio-ds'

import { useLumi } from '../hooks/useLumi'

import * as S from './post.styles'

export const Post = () => {
    const [isTextAreaView, setIsTextAreaView] = useState(false)
    const [textAreaValue, setTextAreaValue] = useState('')
    const { onChangeAcceptedFiles } = useLumi()

    const { acceptedFiles, getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
        accept: {
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            'application/pdf': ['.pdf'],
            'text/csv': ['.csv'],
            'application/vnd.ms-excel': ['.xls'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
        },
    })

    useEffect(() => {
        return onChangeAcceptedFiles(acceptedFiles)
    }, [acceptedFiles])

    const handleToggleTextAreaView = () => {
        setIsTextAreaView((prevState) => !prevState)
    }

    const handleChangeTextArea = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setTextAreaValue(event.target.value)
    }

    return (
        <S.PostWrapper>
            {!isTextAreaView && (
                <>
                    <S.Title>Submit your job post</S.Title>

                    <S.Dropzone {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
                        <input {...getInputProps()} />

                        {isDragReject ? (
                            <>
                                <S.IconWrapper isDragReject={isDragReject}>
                                    <AlertIcon type="bold" color={colors.primaryWhite} />
                                </S.IconWrapper>

                                <S.DropzoneTitle>File format not supported</S.DropzoneTitle>
                            </>
                        ) : (
                            <>
                                <S.IconWrapper>
                                    <DownloadIcon type="bold" color={colors.primary50} />
                                </S.IconWrapper>

                                <S.DropzoneTitle>Drag and Drop Files to upload.</S.DropzoneTitle>
                            </>
                        )}

                        <S.DropzoneDescription>
                            Accepted formats .doc, .docx, .pdf, .csv, .xls, .xlsx
                        </S.DropzoneDescription>
                    </S.Dropzone>

                    <Button
                        onClick={handleToggleTextAreaView}
                        rightIcon={<EditIcon type="line" />}
                        color="secondaryLight"
                    >
                        Enter Text Instead
                    </Button>
                </>
            )}

            {isTextAreaView && (
                <>
                    <S.Title>Submit your job post</S.Title>

                    <S.Textarea
                        placeholder="Enter job post here"
                        onChange={handleChangeTextArea}
                        value={textAreaValue}
                        autoFocus
                    />

                    <S.TextareaButtons>
                        <Button onClick={handleToggleTextAreaView} color="secondaryLight">
                            Back
                        </Button>

                        <Button onClick={() => {}} color="primary" disabled={textAreaValue.length === 0}>
                            Add to queue
                        </Button>
                    </S.TextareaButtons>
                </>
            )}
        </S.PostWrapper>
    )
}
